export default __webpack_public_path__ + "da8efd7a08f60ae6094562f01045551e.png";